import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RendimentoPedagogicoLayer from "../components/RendimentoPedagogicoLayer";
import { useTranslation } from "../i18n/I18nContext";

const RendimentoPedagogicoPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("rendimento.breadcrumb")} />
      <RendimentoPedagogicoLayer />
    </MasterLayout>
  );
};

export default RendimentoPedagogicoPage;
